import { InjectionToken } from '@angular/core';
import { RomeUiLoaderConfig } from '../utils/interfaces';

/**
 * Injection token for ui-loader configuration
 */
export const ROME_UI_LOADER_CONFIG_TOKEN = new InjectionToken<RomeUiLoaderConfig>('romeUiLoaderCustom.config');
